<template>
  <section>
    <v-dialog
      v-model="dialog"
      width="420px">
      <div class="dialog-container">
        <div class="plan-header">
          <div class="info flex">
            <span class="title fs-14 fw-600 color-dark">Add/Subtract</span>
            <i
              class="el-icon-close"
              @click="handleCancel"></i>
          </div>
        </div>
        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <div class="dialog-body">
            <div class="form-item">
              <el-form-item
                ref="add"
                prop="add"
                :rules="rules.select">
                <v-radio-group
                  v-model="formData.add"
                  :list="voteList"></v-radio-group>
              </el-form-item>
            </div>
            <div class="form-item">
              <el-form-item
                ref="num"
                prop="num"
                :rules="rules.input">
                <v-input
                  v-model="formData.num"
                  key-number
                  :max="formData.add==0?maxVote:null"
                  :prepend="formData.add==1?'+':'-'"></v-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="dialog-footer">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <div>
            <v-button
              green
              @click="onContinue">Confirm</v-button>
          </div>
        </div>
      </div>

    </v-dialog>
  </section>

</template>
<script>
import MixinRules from '@/mixins/rules'
import {controlVoteTraveller} from '@/api/pop-traveller-team'
import MixinOptions from '@/mixins/options'

export default {
  name: 'AddSubtractDialog',
  components:{
  },
  mixins: [MixinRules,MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    detailData: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: [String, Number],
      default: ''
    },
    value:{
      type:Boolean,
      default:false
    },
    maxVote:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      dialog: false,
      formData: {
        num:'',
        add:''
      },
    }
  },
  computed:{
  },
  watch: {
    value:{
      immediate: true,
      handler(val){
        this.dialog = val
      }
    }
  },
  methods: {
    handleCancel(){
      this.dialog = false
      this.$emit('input',this.dialog)
    },
    onContinue() {
      this.$refs.form.validate( (valid) => {
        if (valid) {
          this.network().controlVoteTraveller()
        }
      })
    },
    network() {
      return {
        controlVoteTraveller: async (params) => {
          let team_id = this.$route.params.id
          params = {
            team_id,
            ...this.formData
          }

          const { data } = await controlVoteTraveller(params)
          this.dialog = false
          this.$emit('input',this.dialog)
          this.$emit('refresh')

        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  //padding: 15px;
  .plan-header {
    padding: 15px;
    background: #F6F8FA;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      //padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
      h3{
        padding-bottom: 0;
      }
    }
  }
  .dialog-footer {
    //margin: 15px -15px -15px;
    display: flex;
    justify-content: space-between;
    padding: 16px;
    padding-top: 0;
    text-align: right;
  }
  .form-item {
    & > span {
      font-weight: bold;
      font-size: 16px;
    }
  }
  .dialog-body{
    padding: 16px;
    padding-bottom: 0;
    .flex{
      margin-bottom: 10px;
      span{
        width: 120px;
        margin-right: 15px;
        color: $dark;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        &:last-child{
          color:  #6A737D;
          font-weight: 600;
        }
      }
    }

  }
}
/deep/.el-radio-group{
  display: flex;
.el-radio{
  width: 50%;
}
}
</style>
